import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  position: 'relative',
};

export const label: SxStyle = {
  position: 'absolute',
  ml: 5,
  top: 13,
  bottom: 0,
  fontSize: (p) => p.typography.caption,
  color: (p) => p.palette.grey[400],
};

export const chip: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[500],
  background: (p) => p.palette.primary[50],
  borderRadius: (p) => p.spacing(1.5),
  color: (p) => p.palette.primary[500],

  mr: (p) => p.spacing(1),
};

export const deleteIcon: SxStyle = {
  color: (p) => p.palette.primary[500],
};

export const optionItem: SxStyle = {
  px: (p) => p.spacing(1.5),
  py: (p) => p.spacing(1),
  cursor: 'pointer',
  borderRadius: (p) => p.spacing(1),
  ':hover': {
    background: (p) => p.palette.primary[50],
    color: (p) => p.palette.primary[500],
  },
};
